/** KDS Date picker design tokens — Figma node 260:4837. */

import { selectTriggerHeightPx } from '../select/select.kds';

export const datePickerSizes = ['sm', 'md'] as const;

export type DatePickerSize = (typeof datePickerSizes)[number];

export const datePickerDefaultSize: DatePickerSize = 'sm';

/** Figma day cell width (px). */
export const datePickerCellWidthPx = 40;

/** Figma day cell height (px). */
export const datePickerCellHeightPx = 36;

/** Figma header control height — Dropdown Small (`select` sm). */
export const datePickerHeaderControlHeightPx = selectTriggerHeightPx.sm;

/** Default display format (legacy org date-picker). */
export const datePickerDefaultDisplayFormat = 'MMM dd, yyyy';

/** Default value returned from `onChange` (legacy org/admin). */
export const datePickerDefaultReturnFormat = 'yyyy-MM-dd';

/** Default placeholder. */
export const datePickerDefaultPlaceholder = 'Select';

/** Figma calendar popover shadow. */
export const datePickerPopoverShadow = '0px 4px 8px 0px rgba(24, 36, 60, 0.15)';

/** Minimum calendar popover width — 7 day columns + horizontal padding (px). */
export const datePickerPopoverMinWidthPx = 7 * datePickerCellWidthPx + 24;

/** Figma Dropdown menu shadow (node 1077:2357). */
export const datePickerDropdownMenuShadow =
  '0px 3px 6px -3px rgba(23, 24, 24, 0.08), 0px 8px 20px -4px rgba(23, 24, 24, 0.12)';

/** Figma year header select width (px). */
export const datePickerYearSelectWidthPx = 88;

/** Gap between month/year selects (Figma sm = 8px, node 286:5719). */
export const datePickerHeaderSelectGapPx = 8;

/** Gap between prev/next nav buttons (Figma 2xs = 4px, node 1063:11939). */
export const datePickerNavButtonGapPx = 4;

/** Gap between dropdown group and nav group (Figma sm = 8px, node 286:5719). */
export const datePickerHeaderSectionGapPx = 8;

/** Figma nav icon button size (px). */
export const datePickerNavIconSizePx = 18;
